import React from "react";
import { connect } from "react-redux";

import { ApplicationState } from "../../reducers";
import { User, UserRole } from "../../domain/domain";
import { compose } from "redux";
import { UserActionType } from "../../reducers/user.reducer";
import { Menu, MenuItem } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { logout } from "../../api/user";


type Props = {
    currentUser: User,
    onMenuClosed: () => void,
    dispatch: (msg: any) => void,
    open: boolean,
    anchorEl: any
}

const UserMenu: React.FC<Props> = ({ open, currentUser, anchorEl, dispatch, onMenuClosed }) => {

    const history = useHistory();

    return (
        <Menu
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 35, horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={open}
            anchorEl={anchorEl} onClose={() => {
                onMenuClosed();
            }}>
            {currentUser.userRole === UserRole.ADMINISTRATOR &&
                <MenuItem onClick={() => {
                    history.push('/admin');
                    onMenuClosed();
                }}>Admin Dashboard</MenuItem>
            }
            <MenuItem onClick={() => {
                logout().then(() => {
                    dispatch({ type: UserActionType.USER_LOGOUT });
                }).catch(error => {
                    console.error('Logout error:', error);
                    localStorage.removeItem("ACCESS_TOKEN");
                    dispatch({ type: UserActionType.USER_LOGOUT });
                });
            }}>Log Out</MenuItem>
        </Menu>
    );

};

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentUser: state.user.currentUser
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return { dispatch };
}

export default compose<any>(
    connect(mapStateToProps, mapDispatchToProps)
)(UserMenu);

